export default __webpack_public_path__ + "static/media/upload.cfad0527.svg";